module.exports = __webpack_public_path__ + "media/img/pages/profile/fenaco ger 4-d2c28e05ad8a48249902fd331ca43cc4.jpg";